import FilterNav from '../../molecules/filterNav/FilterNav';
import styles from './SearchItemContainer.module.scss';
import BoxContainer from '../../molecules/boxContainer/BoxContainer';
import ButtonBox from '../../atoms/buttonBox/ButtonBox';
import PropTypes from 'prop-types';
import { isArrayNotEmpty } from '../../../utils/helperServices';

const PlanNameMobile = (props) => {

  const resetPlanName = () => {
    props.setSelectedFilter(props.tempSelectedFilter);
  };
	
	const handleBack = () => {
		resetPlanName();
		props.hidePlanName();
	}

	return (
    <div className={styles.navGutter}>
      <FilterNav
        headingName="Plan name"
        backbtn={handleBack}
        resetClickHandler={props.resetClickHandler}
        selectedFilter={isArrayNotEmpty(props?.selectedFilter?.plannames)}
      />
      {props.planname.map((promo) => (
        <BoxContainer
          key={promo.id}
          boxHeading={promo.label}
          selected={props.isPlanNameChecked(promo)}
          selectHandler={(flag) => props.plannameClickHandler(flag, promo)}
        />
      ))}

      <ButtonBox
        children="Save Selection"
        className={styles["botton-box"]}
        click={props.hidePlanName}
      />
    </div>
  );
};


PlanNameMobile.propTypes = {
	hidePlanName: PropTypes.bool,
	resetClickHandler: PropTypes.func,
	planname: PropTypes.array,
	isPlanNameChecked: PropTypes.any,
	plannameClickHandler: PropTypes.func,
	selectedFilter: PropTypes.object,
  tempSelectedFilter: PropTypes.object
};

export default PlanNameMobile;